import { render, staticRenderFns } from "./CircularImage.vue?vue&type=template&id=19b9a66e&scoped=true"
import script from "./CircularImage.vue?vue&type=script&lang=js"
export * from "./CircularImage.vue?vue&type=script&lang=js"
import style0 from "./CircularImage.vue?vue&type=style&index=0&id=19b9a66e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b9a66e",
  null
  
)

export default component.exports